import { Collection } from 'vue-mc'
import axiosConfig from './Config'

export default class extends Collection {
	public getRequest(config: any) {
		axiosConfig(config)
		return super.getRequest(config)
	}
}
